import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[(_vm.$route.path !== '/login')?_c('Cabecalho'):_vm._e(),_c('router-view'),(_vm.$route.path !== '/login')?_c('Rodape'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }